import cn from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Colors } from '../../theme/generated/Colors.ts'
import { ImagePlaceholder } from '../ImagePlaceholder.tsx'
import { UserPick } from '../icons/UserPic.tsx'
import styles from './avatar.module.less'

export enum AvatarVariant {
    square,
    circle
}

export enum PlaceholderType {
    human,
    picture
}

interface AvatarProps {
    size?: number
    uri?: string | null
    variant?: AvatarVariant
    placeholder?: React.ReactNode
    placeholderType?: PlaceholderType
    bgColor?: Colors
}

const borderRadius = {
    [AvatarVariant.circle]: (size: number) => size / 2,
    [AvatarVariant.square]: (_: number) => 4
}

const getPlaceholder = {
    [PlaceholderType.human]: (size: number) => <UserPick color={Colors.Obsidian_Dark_200} size={size} />,
    [PlaceholderType.picture]: (size: number) => <ImagePlaceholder color={Colors.Obsidian_Dark_200} size={size * 0.7} />
}

export const Avatar: React.FC<AvatarProps> = ({
    placeholderType = PlaceholderType.human,
    placeholder,
    size = 84,
    uri,
    variant = AvatarVariant.circle,
    bgColor = Colors.Coral_fire_400,
}) => {
    const [error, setError] = useState(false)
    const { t } = useTranslation()
    return (
        <div
            className={cn(styles.root, { [styles.loaded]: !error && uri })}
            style={{
                height: size,
                width: size,
                borderRadius: borderRadius[variant](size),
                backgroundColor: bgColor
            }}
        >
            {uri && !error ? (
                <img
                    className={styles.image}
                    onError={() => setError(true)}
                    alt={t('Avatar')}
                    src={uri}
                />
            ) : (
                placeholder || getPlaceholder[placeholderType](size)
            )}
        </div>
    )
}